// extracted by mini-css-extract-plugin
module.exports = {"className":"IconCheckbox--className","icon":"IconCheckbox--icon","checked":"IconCheckbox--checked","disabled":"IconCheckbox--disabled"};